<div [formGroup]="mainForm" id="top">
  <app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray" />
  <h1>口座振替・クレジット申込書一括印刷</h1>	
  <app-sgkd004d-search-condition
    (responseEmitter)="setResult($event)"
    (clearMessageEvent)="clearMessage()"
  />
  <app-sgkd004d-search-result
    (clearMessageEvent)="clearMessage()"
    (setMessageEvent)="pushSgAriaMessage($event)"
  />
</div>